<template>
  <v-card>
    <v-card-title class="pb-0">
      <v-layout column>
        <h1 class="headline">
          {{ title }}
        </h1>
        <h2
          v-if="user.isRemoved"
          class="subheading red--text my-1"
        >
          {{ subTitle }}
        </h2>
      </v-layout>
    </v-card-title>
    <v-card-text>
      <v-layout
        row
        wrap
        align-center
      >
        <!--AVATAR-->
        <v-flex
          v-if="!isNew"
          xs12
          md2
          style="height:272px"
        >
          <v-layout
            align-center
            justify-space-between
            column
            wrap
          >
            <v-flex>
              <img
                id="user-avatar-img"
                :src="userAvatar"
              >
              <input
                id="get-file-dialog"
                type="file"
                accept=".jpg, .png, .bmp"
                @change="handleFiles"
              >
            </v-flex>
            <v-flex>
              <v-layout
                align-center
                justify-center
              >
                <v-btn
                  small
                  icon
                  :disabled="user.isRemoved"
                  @click="openFileOption"
                >
                  <v-icon color="grey darken-1">
                    edit
                  </v-icon>
                </v-btn>
                <v-btn
                  small
                  icon
                  :disabled="user.isRemoved"
                  @click="removeAvatar"
                >
                  <v-icon color="grey darken-1">
                    delete
                  </v-icon>
                </v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex>
          <v-form
            v-model="valid"
            class="ml-3"
          >
            <v-layout>
              <v-flex v-if="isNew">
                <v-layout
                  row
                  wrap
                >
                  <v-flex
                    xs12
                    sm6
                    md6
                  >
                    <v-text-field
                      v-model="user.title"
                      class="ma-2"
                      label="Ф.И.О."
                      hide-details
                      outline
                      height="44"
                      :disabled="user.isRemoved"
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md6
                  >
                    <v-text-field
                      v-model="user.email"
                      v-validate="'email'"
                      class="ma-2"
                      :error-messages="errors.collect('user.email')"
                      label="Email*"
                      hide-details
                      :required="true"
                      data-vv-name="user.email"
                      outline
                      height="44"
                      :disabled="user.isRemoved"
                      @input="changeEmail()"
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md6
                  >
                    <v-text-field
                      v-model="user.userName"
                      class="ma-2"
                      :required="true"
                      :rules="[
                        v => !!v || 'Поле обязательно к заполнению',
                        v =>
                          v.length >= 1 ||
                          'Поле должно содержать не менее 1-х символа'
                      ]"
                      label="Login*"
                      hide-details
                      outline
                      height="44"
                      :disabled="user.isRemoved"
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md6
                  >
                    <v-text-field
                      v-model="user.password"
                      class="ma-2"
                      :required="true"
                      :rules="[
                        v => !!v || 'Поле обязательно к заполнению',
                        v =>
                          v.length >= 4 ||
                          'Поле должно содержать не менее 4-х символа'
                      ]"
                      label="Пароль*"
                      hide-details
                      outline
                      height="44"
                      :disabled="user.isRemoved"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <MultipleEnumSelect
                      v-model="user.roles"
                      class="ma-2"
                      label="Роли"
                      resource="user-roles"
                      :required="true"
                      :outline="true"
                      :height-field="44"
                      :disabled="user.isRemoved"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex
                v-else
                xs12
                md10
              >
                <v-flex xs1>
                  <v-text-field
                    class="ml-2"
                    :value="user.id"
                    label="Ид"
                    :disabled="true"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md10
                >
                  <v-text-field
                    v-model="user.title"
                    class="ma-2"
                    label="Ф.И.О."
                    hide-details
                    outline
                    height="44"
                    :disabled="user.isRemoved"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md10
                >
                  <v-text-field
                    v-model="user.userName"
                    class="ma-2"
                    label="Login*"
                    :required="true"
                    :rules="[v => !!v || '', v => v.length >= 1 || '']"
                    hide-details
                    outline
                    height="44"
                    :disabled="user.isRemoved"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md10
                >
                  <v-text-field
                    v-model="user.email"
                    v-validate="'email'"
                    class="ma-2"
                    :error-messages="errors.collect('user.email')"
                    label="Email*"
                    hide-details
                    :required="true"
                    data-vv-name="user.email"
                    outline
                    height="44"
                    :disabled="user.isRemoved"
                    @input="changeEmail()"
                  />
                </v-flex>
                <v-flex
                  v-if="user.roleId === 2"
                  xs12
                  md10
                >
                  <app-reference
                    v-model="user.client"
                    class="mx-2"
                    :required="true"
                    :rules="[v => !!v || '']"
                    label="Клиент"
                    resource="clients"
                    component-name="Client"
                    :outline="true"
                    :height-field="44"
                    :disabled="user.isRemoved"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md10
                >
                  <MultipleEnumSelect
                    v-model="user.roles"
                    class="ma-2"
                    label="Роли"
                    resource="user-roles"
                    :required="true"
                    :outline="true"
                    height-field="auto"
                    :disabled="!isAdmin || user.isRemoved"
                  />
                </v-flex>
              </v-flex>
            </v-layout>
            <v-btn
              small
              color="primary"
              :disabled="!valid || user.isRemoved"
              @click="submit()"
            >
              Сохранить
            </v-btn>
            <v-btn
              small
              @click="cancel"
            >
              Отмена
            </v-btn>
          </v-form>
          <!--Passwod form-->
          <v-form
            v-if="!isNew"
            v-model="validPasswordForm"
            class="ml-3 mt-1"
          >
            <v-layout
              v-if="showChangePasswordForm"
              wrap
            >
              <v-flex
                xs12
                md4
              >
                <v-text-field
                  v-model="oldPassword"
                  class="mx-2 my-1"
                  :rules="passwordRules"
                  label="Текущий пароль"
                  outline
                  height="44"
                />
              </v-flex>
              <v-flex
                xs12
                md4
              >
                <v-text-field
                  v-model="newPassword"
                  class="mx-2 my-1"
                  :rules="passwordRules"
                  label="Новый пароль"
                  outline
                  height="44"
                />
              </v-flex>
            </v-layout>
            <v-layout v-if="!showChangePasswordForm">
              <v-btn
                v-if="!showChangePasswordForm"
                small
                :disabled="user.isRemoved"
                @click="changePasswordFormControl()"
              >
                Изменить пароль
              </v-btn>
              <v-spacer />
              <v-btn
                :color="user.isRemoved ? 'success' : 'error'"
                small
                :loading="removeLoading"
                @click="changeRemovedState"
              >
                {{ user.isRemoved ? "Восстановить" : "Удалить" }}
              </v-btn>
            </v-layout>
            <v-layout v-if="showChangePasswordForm">
              <v-btn
                small
                color="primary"
                :disabled="!valid || user.isRemoved"
                @click="changePassword()"
              >
                Сохранить пароль
              </v-btn>
              <v-btn
                small
                :disabled="user.isRemoved"
                @click="changePasswordFormControl()"
              >
                Отмена
              </v-btn>
            </v-layout>
          </v-form>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import auth from "./../../auth.js";
import * as usersApi from "../../backend/usersApi.js";
import { NestedEditorsEventBus } from "../../components/nested-editors/nested-editors-event-bus.js";
import redirectRoute from "../../helpers/redirectRoute.js";

export default {
  props: ["id"],
  data() {
    return {
      showChangePasswordForm: false,
      passwordRules: [
        v => !!v || "Поле обязательно к заполнению",
        v =>
          (v !== undefined && v.length >= 4) ||
          "Поле должно содержать не менее 4-х символов",
      ],
      oldPassword: "",
      newPassword: "",
      valid: false,
      validPasswordForm: false,
      user: {
        id: 0,
        title: "",
        userName: "",
        client: null,
        roles: [],
        password: "",
        avatar: null,
        email: "",
        isRemoved: false,
        removedDate: null,
      },
      emailRule: value => {
        // eslint-disable-next-line max-len
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
      removeLoading: false,
    };
  },
  computed: {
    title() {
      return this.isNew
        ? "Создание пользователя"
        : "Редактирование пользователя";
    },
    subTitle() {
      return this.user.isRemoved
        ? `Пользователь заблокирован: ${this.$options.filters.dateTime(
          this.user.removedDate,
        )}`
        : "";
    },
    isNew() {
      return this.id && this.id === "0";
    },
    isModal() {
      let parent = this.$parent;
      while (parent) {
        if (parent.$options._componentTag === "NestedEditors") {
          return true;
        }
        parent = parent.$parent;
      }
      return false;
    },
    userAvatar() {
      if (this.user.avatar) {
        return this.user.avatar;
      } else {
        // eslint-disable-next-line max-len
        return "data:image/jpeg;base64,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";
      }
    },
    isAdmin() {
      const result = auth.getUser().roles.find(item => {
        return item.id === 0;
      });
      return !!result;
    },
  },
  created() {
    if (+this.id) {
      this.getData();
    }
  },
  mounted() {
    if (this.isModal) {
      NestedEditorsEventBus.$emit("modal-editor-mounted");
    }
  },
  methods: {
    async getData() {
      const result = await usersApi.getUser(this.id);
      this.user.id = result.id;
      this.user.title = result.title;
      this.user.userName = result.userName;
      this.user.roles = result.roles;
      this.user.avatar = result.avatar;
      this.user.email = result.email;
      this.user.isRemoved = result.isRemoved;
      this.user.removedDate = result.removedDate;
      setTimeout(() => {
        this.user.client = result.client;
      }, 100);
    },
    async changePassword() {
      await usersApi.changePassword(
        this.id,
        this.oldPassword,
        this.newPassword,
      );
      this.showInfo("Пароль изменен");
      this.showChangePasswordForm = false;
      this.clearPasswordForm();
    },
    changePasswordFormControl() {
      this.showChangePasswordForm = !this.showChangePasswordForm;
      this.clearPasswordForm();
    },
    clearPasswordForm() {
      this.oldPassword = "";
      this.newPassword = "";
    },
    async submit() {
      const entity = {
        userName: this.user.userName,
        password: this.user.password,
        title: this.user.title,
        email: this.user.email,
        roleIds: this.user.roles.map(item => {
          return item.id;
        }),
        clientId: this.user && this.user.client ? this.user.client.id : null,
      };
      if (!this.user.id) {
        const res = await usersApi.createUser(entity);
        this.user.id = res.data;
        this.showInfo("Пользователь добавлен");
        this.$router.replace("/users/" + res.data);
      } else {
        await usersApi.updateUser(this.user.id, entity);
        const user = auth.getUser();
        if (this.user.id === user.id) {
          user.name = this.user.userName;
          user.roles = this.user.roles;
          user.title = this.user.title;
          auth.setUser(user);
          this.$emit("changeUser");
        }
        this.showInfo("Пользователь изменен");
      }
    },
    openFileOption() {
      var inputElement = document.getElementById("get-file-dialog");
      inputElement.click();
    },
    handleFiles(ev) {
      const file = ev.target.files[0];

      const reader = new FileReader();

      reader.onload = () => this.changeAvatar(this.user.id, reader);

      reader.readAsDataURL(file);
    },
    async changeAvatar(id, reader) {
      await usersApi.updateAvatar(id, reader.result);
      const avatarImg = reader.result;
      this.user.avatar = avatarImg;
      const user = auth.getUser();
      if (this.user.id === user.id) {
        user.avatar = avatarImg;
        auth.setUser(user);
        this.$emit("changeUser");
      }
      this.showInfo("Аватар установлен");
    },
    async removeAvatar() {
      var inputElement = document.getElementById("get-file-dialog");
      inputElement.value = null;
      await usersApi.removeAvatar(this.user.id);
      this.user.avatar = null;
      const user = auth.getUser();
      if (this.user.id === user.id) {
        user.avatar = null;
        auth.setUser(user);
        this.$emit("changeUser");
      }
      this.showInfo("Аватар удален");
    },
    changeEmail(value) {
      return value;
    },
    cancel() {
      if (this.isModal) {
        NestedEditorsEventBus.$emit("close");
        return;
      }
      this.$router.go(-1);
    },
    async changeRemovedState() {
      this.removeLoading = true;
      await usersApi.changeRemovedState(this.user.id, this.user.isRemoved);
      await this.getData();
      this.removeLoading = false;
      this.showInfo(
        this.user.isRemoved
          ? "Пользователь заблокирован"
          : "Пользователь восстановлен",
      );
    },
  },
  beforeRouteEnter(to, from, next) {
    redirectRoute(to, from, next);
  },
};
</script>

<style>
#user-avatar-img {
  height: 174px;
  width: 174px;
  border-radius: 50%;
  overflow: hidden;
}
</style>
